import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=f0b3d16c"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"
import style0 from "./index copy.vue?vue&type=style&index=0&id=f0b3d16c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0b3d16c')) {
      api.createRecord('f0b3d16c', component.options)
    } else {
      api.reload('f0b3d16c', component.options)
    }
    module.hot.accept("./index copy.vue?vue&type=template&id=f0b3d16c", function () {
      api.rerender('f0b3d16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/usermanager/index copy.vue"
export default component.exports